export default {
  common: {
    requests: 'Richieste',
    request: 'Richiedi',
    signUp: 'Iscriviti',
    logOut: 'Disconnettiti',
    seeAll: 'Vedi tutto',
    follow: 'Seguire',
    unfollow: 'Non seguire',
    email: 'Email',
    fullName: 'Nome e cognome',
    password: 'Password',
    next: 'Prossimo',
    addNew: 'Aggiungi nuovo',
    type: 'Tipo',
    typeYourMessage: 'Digita il tuo messaggio',
    yourMessage: 'Il tuo messaggio',
    message: 'Messaggio',
    shoutOut: 'Shoutout!',
    story: 'Storia',
    chat: 'Chat',
    featureComingSoon: 'Questa funzionalità sarà disponibile a breve!',
    okay: 'Ok',
    send: 'Invia',
    delete: 'Cancella',
    cancel: 'Cancella',
    search: 'Ricerca',
    back: 'Indietro',
    goToHome: 'Vai alla Pagina iniziale',
    addShoutout: 'Aggiungi Shoutout',
    player: 'Atleta',
    text: 'Testo',
    video: 'Video',
    comment: 'Commento',
    team: 'Squadra',
    country: 'Paese',
    city: 'Città',
    userName: 'Nome utente',
    following: 'Segui già',
    followers: 'Follower',
    referals: 'Referenze',
    athletes: 'Atleti',
    shoutouts: 'Shoutout',
    showMore: 'Mostra di più',
    showLess: 'Mostra meno',
    sport: 'Sport',
    position: 'Posizione',
    league: 'Lega',
    info: 'Info',
    repost: 'Riposta',
    share: 'Condividi',
    confirmed: 'Confermato',
    refused: 'Rifiutato',
    pending: 'In attesa di',
    canceled: 'Cancellato',
    trending: 'Di Tendenza',
    latest: 'Ultime novità',
    noData: 'Nessun dato',
    from: 'da',
    to: 'a',
    settings: 'Impostazioni',
    areYouSure: 'Sei sicuro?',
    profile: 'Profilo',
    accept: 'Accetta',
    refuse: 'Rifiuta Tutto',
    missing: 'Mancante',
    select: 'Seleziona',
    currency: 'Valuta',
    zipCode: 'Codice postale',
    goBack: 'Torna indietro',
    done: 'Fatto',
    remove: 'Rimuovi',
    date: 'Data',
    description: 'Descrizione',
    amount: 'Importo',
    upload: 'Carica',
    getApp: "Scarica l'APP",
    today: 'Oggi',
    yesterday: 'Ieri',
    tomorrow: 'Domani',
    confirm: 'Conferma',
    confirmAll: 'Conferma Tutto',
    login: 'Accedi',
    ad: 'AD',
    aboutUs: 'Chi siamo',
    fan: 'Tifoso',
    athlete: 'Atleta',
    stats: 'Statistiche',
    posts: 'Post',
    store: 'Negozio',
    or: 'Oppure',
    shoutout: 'Shoutout',
    proceed: 'Procedi',
    dismiss: 'Revoca',
    save: 'Salva',
    discard: 'Elimina',
    submit: 'Invia',
    live: 'In diretta',
    openInbox: 'Apri la casella di posta',
    home: 'Home',
    searchDotDotDot: 'Ricerca',
    subscribers: 'Abbonati',
    subscribed: 'Abbonato',
    subscribe: 'Abbonati!',
    unsubscribe: "Annulla l'abbonamento",
    fans: 'Tifosi',
    teams: 'Squadre',
    setup: 'Impostazione',
    feed: 'Feed',
    messages: 'Messaggi',
    earlier: 'Prima',
    apply: 'Richiedi',
    oneOnOnes: 'Collegamenti uno-a-uno',
    sort: 'Ordina per',
    comingSoon: 'Prossimamente',
    goLive: 'Vai alla diretta',
    total: 'Totale',
    pay: 'Paga {{amount}}',
    free: 'libero',
    location: 'Posizione',
    countries: 'Paesi',
    more: 'di più',
    less: 'meno',
    block: 'Blocca',
    unblock: 'Sblocca',
    privacyPolicy: 'Informativa sulla privacy',
    termsAndConditions: 'Termini e Condizioni',
    createNew: 'Crea un nuovo',
    game: 'Gioco',
    unlock: 'Sblocca',
    post: 'Post',
    uploadFile: 'Carica il file',
    checkIn: 'Check-in',
    unregisteredType: 'Tipo non registrato',
    required: 'Obbligatorio',
    create: 'Crea',
    reply: 'Risposta',
    caption: 'Descrizione',
    optional: 'opzionale',
    adPlayaz: 'AdPlayaz',
    noPosts: 'Nessun Post',
    noShoutouts: 'Nessun Shoutout'
  },
  sports: {
    americanFootball: 'Football Americano',
    baseball: 'Baseball',
    basketball: 'Pallacanestro',
    boxing: 'Pugilato',
    cricket: 'Cricket',
    soccer: 'Calcio',
    mma: 'MMA',
    race: 'Guida di auto da corsa',
    tennis: 'Tennis',
    carRace: 'Guida di auto da corsa',
    acrobatics: 'Acrobazie',
    airSports: "Sport dell'aria",
    archery: "Tiro con l'arco",
    combatSports: 'Sport da combattimento',
    cycling: 'Ciclismo',
    cueSports: 'Biliardo',
    equestrianSports: 'Sport equestri',
    golf: 'Golf',
    handball: 'Pallamano',
    iceSports: 'Sport sul ghiaccio',
    lacrosse: 'Lacrosse',
    polo: 'Polo',
    weightlifting: 'Sollevamento pesi',
    rowing: 'Canottaggio',
    softball: 'Softball',
    rugby: 'Rugby',
    volleyball: 'Pallavolo',
    coachingMentoring: 'Coaching e mentoring',
    figureSkating: 'Pattinaggio artistico',
    formula1: 'Formula-1',
    gymnastics: 'Ginnastica',
    hockey: 'Hockey',
    kickboxing: 'Kickboxing',
    motorSports: 'Motorsport',
    muayThai: 'Muay Thai',
    olympics: 'Olimpiadi',
    poleSports: 'Pole Sport',
    sportsInfluencer: 'Sport Influencer ',
    swimming: 'Nuoto',
    trackField: 'Atletica leggera',
    visualArtist: 'Artista visuale',
    wheelchairRugby: 'Rugby in carrozzina',
    wrestling: 'Wrestling',
    iceHockey: 'Hockey su ghiaccio',
    alpineSkiing: 'Sci alpino',
    flagFootball: 'Flag Football',
    climbing: 'Arrampicata',
    badminton: 'Badminton',
    motorcycleRacing: 'Motociclismo'
  },
  levels: {
    interested: 'Interessato',
    beginner: 'Principiante',
    amateur: 'Amatore',
    intermediate: 'Intermedio',
    expert: 'Esperto',
    retired: 'Ritirato'
  },
  auth: {
    signUpFacebook: 'Iscriviti cpn Facebook',
    signUpGoogle: 'Iscriviti con Google',
    signUpPaypal: 'Iscriviti con PayPal',
    forgottenPassword: 'Hai dimenticato la tua password?',
    logInFacebook: 'Accedi con Facebook',
    logInGoogle: 'Accedi con Google',
    logInPaypal: 'Accedi con PayPal',
    dontHaveAccount: 'Non hai un account?',
    mustContain8Characters: 'Deve contenere almeno otto caratteri.',
    alreadyHaveAccount: 'Hai già un account?',
    passwordReset: 'Ripristino della password',
    resetInstructions:
      "Inserisci l'email associata al tuo account e ti invieremo le istruzioni per il recupero della password.",
    sendRecoveryEmail: "Invia un'email di recupero",
    backTo: 'Torna a',
    logIn: 'Accedi',
    checkEmail: 'Controlla il tuo indirizzo email',
    noAccount: "Non c'è nessun account associato",
    pleaseTryAnother: 'Prova con un altro indirizzo.',
    tryAnother: "Prova a inviare un'altra email",
    emailSent: 'Email di recupero inviata',
    checkEmailInstructions:
      'Controlla la tua posta in arrivo (e le cartelle di spam) per trovare e seguire le istruzioni per reimpostare la password.',
    createNewPassword: 'Crea una nuova password',
    newPassword: 'Nuova password',
    confirmPassword: 'Conferma la password',
    resetPassword: 'Reimposta la password',
    validateYourEmail: 'Convalida la tua email',
    validateEmailInstructions:
      "È necessario convalidare l'email di attivazione del nuovo account P4P.",
    confirmEmail: "Conferma l'email",
    validationEmailSent: 'Email di convalida inviata',
    checkInboxToValidateEmail:
      "Controlla la tua casella di posta (e le cartelle di spam) per trovare e seguire le istruzioni per convalidare l'email.",
    getTheApp: "Scarica l'APP",
    accountLocked: 'Il tuo account è bloccato',
    accountLockedDesc:
      'Per motivi di sicurezza, abbiamo bloccato il tuo account a causa di troppi tentativi con credenziali sbagliate. Controlla la tua casella di posta per reimpostare la password.',
    checkInbox: 'Controlla la mia casella di posta',
    youAcceptTerms:
      "Registrandoti o effettuando il login, l'utente accetta i nostri Termini e Condizioni e la nostra Informativa sulla privacy.",
    logInApple: 'Accedi con Apple',
    signUpApple: 'Iscriviti con Apple',
    invalidEmail: 'Formato email non valido.',
    promptAuthMsg: 'Devi creare un account per eseguire questa azione.'
  },
  messages: {
    newMessages: 'Nuovi messaggi',
    newGroup: 'Nuovo gruppo',
    favorites: 'Preferiti',
    favoritesAtTop: 'I Preferiti in alto',
    favoritesOnly: 'Solo i Preferiti',
    excludeHidden: 'Escludi le informazioni nascoste',
    showHidden: 'Mostra le informazioni nascoste',
    hiddenChats: 'Chat nascoste',
    message: 'Messaggio',
    addChat: 'Aggiungi chat',
    searchFriends: 'Ricerca amici',
    createdGroup: '{{group}} ha creato questo gruppo',
    totalMessageSingular: '1 Nuovo messaggio',
    totalMessages: '{{totalMessageCount}} Nuovi messaggi',
    noChats: 'Non sono disponibili chat.',
    noChatSelected: 'Non è stata selezionata alcuna chat.',
    messageDotDotDot: 'Messaggio...',
    noChatYet: "Qui non c'è ancora nessuna chat...",
    searchFriendsGroups: 'Cerca amici o gruppi...',
    selectFriend: 'Seleziona un amico',
    groupChatName: 'Nome della chat di gruppo',
    startChat: 'Avvia la chat',
    youNeedSub: 'Devi iscriverti a {{name}} per inviare un messaggio',
    youBlocked: 'Hai bloccato questo utente'
  },
  home: {
    latestPosts: 'I post più recenti',
    confirmed: 'Confermato',
    playazRunsSafeEnvironment: 'Playaz gestisce un ambiente sicuro',
    connectionsConverstationsFollowedAthletes:
      'Connessioni con persone con stesse preferenze per avere conversazioni, incontri di gruppo e imparare dagli atleti seguiti.',
    myPosts: 'I miei post',
    accountsToFollow: 'Profili da seguire',
    comingUp: 'In arrivo',
    gloriousWinners: 'Vincitori gloriosi',
    todaysGames: 'Giochi di oggi',
    athleteHighlights: "Highlights dell'atleta",
    fanHighlights: 'Highlights dei Tifosi',
    todaysMatches: 'Le partite di oggi'
  },
  add: {
    followers: 'Follower',
    subscribers: 'Abbonati',
    onlyMe: 'Solo io',
    photoVideo: 'Foto/Video',
    tag: 'Tagga',
    editMedia: 'Modifica media',
    tapCrop: "Clicca su un'immagine per ritagliarla.",
    gallery: 'Galleria',
    addMultiple: 'Aggiungi più',
    shoutOutTo: 'Shoutout a',
    whereItHappens: 'Dove succede',
    shouldAcceptTerms: 'È necessario accettare i Termini e le Condizioni',
    summary: 'Riepilogo',
    total: 'Totale',
    iAcceptTerms:
      "Come da Termini e Condizioni, accetto che mi venga addebitato l'importo sopra indicato al momento della conferma dell'atleta.",
    post: 'Post',
    enterYoutubeLink: 'Inserire il link di Youtube',
    tagFriends: 'Tagga amici',
    shareWith: 'Condividi con',
    everyone: 'Tutti',
    peopleFollowBack: 'Solo le persone che seguo',
    linkToVideo: 'Link al video',
    swipeRightPurchase: 'Scorri a destra per acquistare',
    uploadMedia: 'Carica media',
    shareLink: 'Condividi il link',
    correctYoutubeLink: 'Aggiungi un link corretto a Youtube.',
    writeCaption: 'Inserisci una descrizione',
    selectionsWillRemove:
      'È possibile pubblicare un solo video, le altre selezioni saranno rimosse. Vuoi procedere?',
    selectVideo: 'Seleziona il video',
    onlySingleVideo: 'Per ora puoi pubblicare un solo video.',
    upToAMinutes: 'È consentito un video della massima lunghezza di 1 minuto.',
    text: 'Testo',
    video: 'Video',
    tagPeople: 'Tagga persone',
    enterLink: 'Inserisci il link',
    linkToOriginalPost: 'Link al post originale',
    pasteForPreview: "Incolla il link per vedere l'anteprima del post",
    createPost: 'Crea un post...',
    recent: 'Recente',
    noUserFound: 'Nessun risultato trovato con i criteri corrispondenti',
    searchResults: 'Risultati della ricerca',
    storyPublished: 'Storia pubblicata!',
    live: 'In diretta',
    shoutout: 'Shoutout!',
    addPhotosAndVideos: 'Aggiungi foto e video',
    addLocation: 'Aggiungi una posizione',
    onlyForSubscribers: 'Solo per gli abbonati',
    photosAndVideos: 'Foto e video',
    selectUpTo10: 'Seleziona fino a 10',
    suggested: 'Suggerito',
    shoutoutTo: 'Uno shoutout a',
    createShoutout: 'Crea uno Shoutout',
    newShoutout: 'Nuovo Shoutout',
    tapOrHold: 'Clicca per foto, tieni premuto per video',
    tapGoLive: 'Clicca per andare in diretta',
    addNewPost: 'Aggiungi un nuovo post',
    addNewShoutout: 'Aggiungi un nuovo shoutout',
    fileFormats: 'Formati di file JPEG, PNG, MP4, WebM o Ogg',
    create: 'Crea',
    correctLink: 'Si prega di aggiungere un link corretto.',
    addShoutout: 'Aggiungi Shoutout',
    teamOrPlayer: 'Squadra o atleta',
    startStreaming: 'Inizia lo streaming',
    createNewShoutout: 'Crea un nuovo Shoutout',
    createNewPost: 'Crea un nuovo post',
    selectFile: 'Seleziona file'
  },
  browse: {
    trySearchAthlete: 'Prova a cercare un atleta, una squadra o un hashtag',
    basedYourPreferences:
      'In base alle tue preferenze, ecco alcuni atleti e tifosi che potresti seguire con interesse.',
    erlingHaaland: 'Erling Haaland',
    parisSaintGermain: 'Paris Saint-Germain',
    trendingPosts: 'Post di tendenza',
    chooseSportAndFavoriteTeam:
      'Scegli gli sport e la tua squadra preferita di atleti per tenerti aggiornato.',
    trendingTeams: 'Squadre di tendenza',
    seeTeamsYourFellow:
      'Vedi le squadre che i tuoi amici tifosi e atleti stanno seguendo in questo momento.',
    atalanta: 'Atalanta',
    serieaFootballClub: 'Società di calcio di Serie A',
    browse: 'Naviga',
    athletesOnPlatform: 'Atleti su P4P',
    fansOnPlatform: 'Tifosi su P4P',
    upcomingEvents: 'Prossimi eventi',
    eventsComingUpYourFavorite:
      'Eventi in arrivo sulla base dei tuoi sport, squadre e atleti preferiti.',
    superBantamweight: 'Pesi Piuma',
    tiffanyVanSoestAlinePereira: 'Tiffany van Soest - Aline Pereira',
    chicagoVenue: 'Chicago, Sede di Chicago',
    suggestedAthletes: 'Atleti consigliati',
    suggestedFans: 'Tifosi consigliati',
    suggestedAccounts: 'Account suggeriti',
    newAppHasArrived: 'È arrivata la nostra nuova APP!',
    newAppDesc:
      "Abbiamo arricchito la tua esperienza in P4P grazie ai tuoi feedback. Divertiti con l'APP aggiornata e rimani sintonizzato per ulteriori aggiornamenti.",
    seeTheApp: "Guarda l'APP",
    postCountSingular: '1 post',
    postCountPlural: '{{count}} post',
    recent: 'Recente',
    top: 'Top',
    athletes: 'Atleti',
    teams: 'Squadre',
    tags: 'Tag',
    fans: 'Tifosi',
    trendingShoutouts: 'Shoutout di tendenza',
    goBrowse: 'Naviga',
    follower: 'Follower',
    followers: 'Follower',
    todaysGames: 'Partite di oggi',
    trendingAthletes: 'Atleti di tendenza',
    trendingFans: 'Tifosi di tendenza',
    allAthletes: 'Tutti gli atleti',
    allFans: 'Tutti i tifosi',
    sortBy: 'Ordina per',
    name: 'Nome',
    popularity: 'Popolarità',
    recentlyRegistered: 'Registrato di recente',
    filterByConnection: 'Filtra per collegamento',
    showAll: 'Mostra tutti',
    showOnlyConnect: 'Mostra solo gli atleti con cui puoi connetterti',
    teamsOnPlatform: 'Squadre su P4P',
    allTeams: 'Tutte le squadre',
    todaysMatches: 'Le partite di oggi'
  },
  chat: {
    muteNotifications: 'Disattivare le notifiche',
    removeFavorites: 'Rimuovi dai preferiti',
    addFavorites: 'Aggiungi ai preferiti',
    clearChatHistory: 'Cancella la cronologia della chat',
    youCannotAction: 'Non è possibile annullare questa azione.',
    deleteConversationWith: 'Cancella la conversazione con',
    deleteConversation: 'Cancella la conversazione',
    unhideChat: 'Mostra la chat',
    hideChat: 'Nascondi la chat',
    clearHistory: 'Cancella la cronologia',
    noResults: 'Nessun risultato...',
    noMessagesYet: 'Non ci sono ancora messaggi qui...',
    returnChat: 'Ritorna alla chat',
    searchMessages: 'Ricerca messaggi...',
    clearConfirmation: 'Sei sicuro di voler cancellare questa chat?',
    deleteConfirmation: 'Sei sicuro di voler cancellare questa chat?',
    block: 'Blocca',
    disableSound: 'Disattiva il Suono',
    muteNotificationsFor: 'Disattiva le notifiche per...',
    thirtyMinutes: '30 minuti',
    oneHour: '1 ora',
    oneDay: '1 giorno',
    oneWeek: '1 settimana',
    oneMonth: '1 mese',
    muteForever: 'In modalità silenziosa'
  },
  comments: {
    succesfullyReactedPost: 'Hai aggiunto con successo una reazione a questo post.',
    beFirstReaction: 'Sii il primo ad aggiungere una reazione',
    comments: 'Commenti',
    noComments: 'Nessun commento',
    comment: 'Commento'
  },
  connect: {
    endOneOnOneWith: 'Termina il collegamento uno-a-uno con',
    youWontGoBackCall: 'Non sarà possibile tornare a questa chiamata a pagamento.',
    sayGoodBye: 'Saluta',
    timeToWrapUp: 'È ora di concludere',
    oneOnOneCall: 'Chiamata uno-a-uno',
    setupConnect: 'Impostazione del collegamento uno-a-uno'
  },
  connectConfirmations: {
    cancelOneOnOne: 'Annulla il collegamento uno-a-uno',
    unfortunatelyCanceled:
      'Purtroppo il tuo collegamento uno-a-uno con {{name}} è stato annullato.',
    timeToStart: 'È ora di iniziare i 15 minuti di collegamento uno-a-uno prenotati con {{name}}',
    swipeCancel: 'Scorri a destra per annullare il collegamento',
    wantCancelOneOnOne: 'Vuoi cancellare il collegamento uno-a-uno',
    youWillPay:
      'Questo non può essere annullato e pagherai una penale di cancellazione ( {{amount}} )',
    fanWillGet:
      'Questo non può essere annullato e il tifoso riceverà un rimborso del 100% ({{amount}}).',
    swipeRightStart: 'Scorri a destra per avviare il collegamento',
    oneOnOneConnectEnded: 'Il collegamento uno-a-uno è terminato',
    '15minCall':
      'La tua chiamata di 15 minuti con {{name}} è terminata, speriamo che tu abbia avuto una conversazione emozionante con il tuo atleta preferito.',
    bookAnotherOneOnOne: 'Prenota un altro collegamento uno-a-uno',
    refuseOneOnOne: 'Rifiuta il collegamento uno-a-uno',
    wantRefuseOneOnOne: 'Vuoi rifiutare il collegamento uno-a-uno con {{name}}',
    swipeRightRefuseConnect: 'Scorri a destra per rifiutare il collegamento',
    '15minCallWithAthlete':
      "La tua chiamata di 15 minuti con {{name}} è terminata, ci auguriamo che tu abbia avuto un'entusiasmante conversazione con il tuo atleta preferito.",
    waitingInLobby: 'Aspettando nella lobby...',
    pleaseWaitUser:
      "Attendi l'inizio del tuo collegamento uno-a-uno con <strong> {{name}} <\/strong> .",
    refusedOneOnOneConnect: 'Collegamento uno-a-uno rifiutato',
    callSettings: 'Impostazioni di chiamata:'
  },
  settings: {
    referAnAthlete: 'Segnala un atleta',
    upgradePlan: 'Piano di aggiornamento',
    settings: 'Impostazioni',
    changePassword: 'Modifica la password',
    oldPassword: 'Vecchia password',
    newPassword: 'Nuova password',
    privacyAndSecurity: 'Privacy e sicurezza',
    profilePrivacySettings: 'Impostazioni sulla privacy del profilo',
    whoCanView: 'Chi può vedere la pagina del tuo profilo?',
    whoCanViewInfo: 'Chi può visualizzare la scheda informazioni sulla pagina del tuo profilo?',
    whoCanViewBasicInfo: 'Chi può vedere le tue informazioni di base?',
    whoCanViewLocation: 'Chi può vedere la tua posizione?',
    whoCanViewActivities:
      'Chi può visualizzare la sezione delle attività sulla pagina del tuo profilo?',
    whoCanShare: 'Chi può condividere un post sulla tua bacheca?',
    whoCanViewFriends: 'Chi può vedere la lista dei tuoi amici?',
    whoCanSendFriends: 'Chi può inviarmi una richiesta di amicizia?',
    whoCanSendMessage: 'Chi può inviare un messaggio?',
    whoCanViewPhotos: 'Chi può visualizzare le foto sulla pagina del profilo?',
    whoCanPokes: 'Chi può inviare i poke?',
    whoCanViewViewed: 'Chi può vedere chi ha visualizzato di recente il tuo profilo?',
    whoCanTag: 'Chi può taggarmi?',
    whoCanSeeDateOfBirth: 'Chi può vedere la tua data di nascita?',
    allowSharing: 'Consenti la condivisione da',
    allowMentions: 'Consenti di essere menzionato da',
    allowTags: 'Consenti i tag da',
    avilabilityPeriod: 'Periodo di disponibilità',
    pleaseShare:
      'Condividi le tue aspettative di guadagno mensile. I tifosi non vedranno questo dato nel tuo profilo.',
    customPeriod: 'Periodo personalizzato...',
    from: 'Da',
    to: 'A',
    selectStart: 'Seleziona la data di inizio',
    selectEnd: 'Seleziona la data di fine',
    total: 'Totale',
    pendingRequest: 'Richieste in sospeso',
    invalid: 'non valido',
    today: 'Oggi',
    months: 'Mesi',
    weeks: 'Settimane',
    setAvailability: 'Imposta la disponibilità',
    fansWillOnly:
      "I tifosi potranno prenotare un collegamento uno-a-uno solo all'interno degli slot disponibili.",
    period: 'Periodo',
    dayOfTheWeek: 'Giorno della settimana',
    daily: 'Giornaliero',
    thisWeek: 'Questa settimana',
    thisMonth: 'Questo mese',
    availableTime: 'Tempo disponibile',
    time: 'Tempo',
    timeBetween: 'Tempo tra i collegamenti',
    breakDuration: 'Durata della pausa',
    setAvailableTime: 'Imposta la tua disponibilità da',
    chooseATime:
      'Scegli un momento della giornata in cui vuoi ricevere le richieste di collegamento uno-a-uno',
    weekDays: 'Giorni della settimana',
    weekends: 'Fine settimana',
    oneOnOneConnect: 'Collegamento uno a uno',
    save: 'Salva',
    search: 'Ricerca',
    subscriptions: 'Abbonamenti',
    emailNotifications: 'Notifiche via email',
    languageAndCurrency: 'Lingua e valuta',
    theme: 'Tema',
    billing: 'Fatturazione',
    accessBilling: 'Accesso alle informazioni di fatturazione',
    logOut: 'Disconnettersi',
    countryCode: 'Codice postale',
    selectCountry: 'Seleziona il paese',
    passwordChangeSuccessful: 'La tua password è stata aggiornata con successo.',
    confirmNewPassword: 'Conferma la nuova password',
    forgotPassword: 'Hai dimenticato la password?',
    enableEmailNotifications: 'Abilita le notifiche via email',
    newComments: 'Nuovi commenti',
    newTags: 'nuovi Tag',
    newSubscriptions: 'Nuovi abbonamenti',
    newFriends: 'Nuovi amici',
    friendRequests: 'Richieste di amicizia',
    notificationForLikes: 'Notifica per i "Mi piace"',
    newMessages: 'Nuovi messaggi',
    photosNotifications: 'Notifiche foto',
    language: 'Lingua',
    currency: 'Valuta',
    anyone: 'Chiunque',
    community: 'Community',
    friendsOnly: 'Solo gli amici',
    noOne: 'Nessuno',
    onlyAvailableViaApp: 'Disponibile solo tramite APP mobile',
    darkMode: 'Modalità Buio',
    contentPrivacySettings: 'Impostazioni sulla privacy dei contenuti',
    setAvailableTimeTo: "Imposta l'orario di disponibilità per",
    chooseATimeTo:
      'Scegli un momento della giornata in cui desideri ricevere richieste di collegamento uno-a-uno',
    removeAccount: "Rimuovi l'account",
    accountPrivacy: 'Account',
    contactUs: 'Contattaci.',
    leaveMessage: 'Lasciaci un messaggio.',
    howCanWeHelp: 'Come possiamo aiutarti?'
  },
  scheduleConnect: {
    '15minutesCall': 'Chiamata di 15 minuti',
    thereIsNo: "Non c'è disponibilità per questa data.",
    selectTime: "Seleziona l'ora",
    bookOneOnOne: 'Prenota un collegamento uno-a-uno',
    youAlreadyHave: 'Hai già un collegamento con questo atleta.',
    scheduleAlreadyExist: 'Il programma già esiste',
    ad: 'AD',
    nextAvailableSlot: 'Prossimo slot disponibile',
    noScheduleFound: 'Nessun programma trovato',
    thisUserHasnt:
      'Questo utente non ha ancora impostato il suo programma. Si prega di ritornare più tardi.',
    schedule: 'Programma',
    today: 'Oggi',
    tomorrow: 'Domani',
    weeks: 'Settimane',
    seeCalendar: 'Vedi il calendario',
    dateAndTime: 'Data e ora',
    edit: 'Modifica',
    total: 'Totale:',
    asPerTheTerms:
      "In accordo con Termini e Condizioni, accetto che mi venga addebitato l'importo sopraindicato al momento della conferma dell'atleta.",
    sendRequest: 'Invia la richiesta',
    oneOnOneRequest: 'Invio di una richiesta di collegamento uno-a-uno',
    afterTheAthleteAccepts:
      "Dopo che l'atleta avrà accettato la tua richiesta, riceverai una notifica e vedrai il collegamento in sospeso sulla dashboard.",
    goToDashboard: 'Vai alla dashboard',
    bookOtherOneOnOne: 'Prenotare un altro collegamento uno-a-uno',
    proceed: 'Procedi',
    searcAthletes: 'Ricerca atleti',
    notVerified: 'Questo profilo non è un atleta verificato.',
    bookOneOnOneTeam: 'Booking a Face2Face? Please select your favorite athlete. Thank you!',
    noBooked: 'Non hai ancora prenotato un collegamento uno-a-uno',
    bookedYet: 'Hai già prenotato un collegamento uno-a-uno?',
    selectDay: 'Seleziona il giorno',
    nextOneOnOnes: 'Prossimi collegamenti uno-a-uno',
    noResults:
      "Tutti i nostri atleti hanno un'agenda fitta di impegni. Le disponibilità si aprono regolarmente, quindi ti invitiamo a tornare più tardi."
  },
  connectsDashboard: {
    byFan: 'DAI TIFOSI',
    byAthlete: "DALL' ATLETA",
    pending: 'In attesa di',
    confirmed: 'Confermato',
    rejected: 'Rifiutato',
    timeBooked: 'Tempo prenotato',
    refuseOneOnOneConnect: 'Rifiutare tutti i collegamenti uno a uno per',
    refuseAll: 'Rifiuta tutti',
    oneOnOneConnect: 'Collegamento uno a uno',
    bookAgain: 'Prenota di nuovo'
  },
  dashboard: {
    monthlyTarget: 'Obiettivo mensile',
    setMonthlyRevenueTarget: 'Non hai ancora fissato il tuo obiettivo di fatturato mensile.',
    useAthleteRefferalCodes:
      'Utilizza i codici per le referenze degli atleti per far crescere la squadra',
    setupRateAndAvailability:
      'Imposta la tariffa e la disponibilità per ottenere richieste di collegamento uno-a-uno',
    shoutouts: 'Shoutout',
    vipConnect: 'Collegamento VIP',
    week: 'Settimana',
    month: 'Mese',
    year: 'Anno',
    all: 'Tutto',
    custom: 'Personalizzato...',
    total: 'Totale',
    dashboard: 'Dashboard',
    referrals: 'Referenze',
    income: 'Reddito',
    users: 'Utenti',
    subscribed: 'Abbonati',
    progress: 'Progressi',
    followers: 'Follower',
    advertising: 'Pubblicità',
    views: 'Visualizzazioni',
    number: 'Numero',
    athleteEmail: "Email dell'atleta",
    meetings: 'Riunioni',
    itemsSold: 'Articoli venduti',
    store: 'Negozio',
    editMonthlyTarget: "Modifica l'obiettivo mensile",
    inviteToGrow: "Digita l'e-mail per inviare un invito e far crescere la squadra.",
    inviteAthletes: 'Invita atleti',
    follower: 'Follower'
  },
  editProfile: {
    sport: 'Sport',
    selectSuport: 'Seleziona uno Sport',
    favoriteTeam: 'Squadra preferita',
    selectTeam: 'Seleziona la Squadra',
    favoritePlayer: 'Atleta preferito',
    selectPlayer: 'Seleziona un atleta',
    addMoreSport: 'Aggiungi uno sport',
    editProfile: 'Modifica il profilo',
    dateOfBirth: 'Data di nascita',
    bio: 'Bio',
    mySport: 'Il mio sport',
    mySports: 'I miei sport',
    position: 'Posizione',
    selectPosition: 'Seleziona una Posizione',
    level: 'Livello',
    selectLevel: 'Seleziona il livello',
    personalInformation: 'Informazioni personali',
    myGender: 'Il mio genere',
    female: 'Femmina',
    male: 'Maschio',
    other: 'Altro',
    imFrom: 'Vengo da',
    yourPhoneNumber: 'Il tuo numero di telefono'
  },
  profile: {
    wantToConnect: 'Volete mettervi in contatto di persona?',
    favoriteSports: 'Sport preferiti',
    favoriteAthlete: 'Atleta preferito',
    referAndReward: 'Guadagna un premio segnalando un atleta',
    invitePeople: 'Invita persone',
    earnMoreReferralFees: 'Guadagna di più invitando gli atleti intorno a te',
    inviteAthleteFan: 'Invita atleti e tifosi',
    typeEmailToInvite: "Digita l'e-mail per inviare un invito e far crescere la squadra.",
    athleteEmail: "Email dell'atleta",
    doesntExists: 'Questo utente non esiste.',
    latestShoutouts: 'I più recenti shoutout',
    mySports: 'I miei sport',
    myEquipment: 'La mia attrezzatura',
    relatedProducts: 'Prodotti correlati',
    bidForEquipment: 'Offerta per la mia attrezzatura',
    goToAppSettings: "Vai alle impostazioni dell'APP",
    recentShoutouts: 'Recenti shoutout',
    recentUpdates: 'Aggiornamenti recenti',
    trendingPosts: 'Post di tendenza',
    following: 'Stai seguendo',
    userNotFound: 'Utente @{{username}} non trovato',
    searchFriendsAndFollowers: 'Ricerca di amici e follower',
    noUpdatesYet: '{{name}} non ha ancora aggiornamenti',
    noPostsYet: '{{name}} non ha ancora postato',
    followToKnowFirst:
      'Segui {{name}} per essere il primo a conoscere gli aggiornamenti, podcast o live streaming.',
    encourage: "Sentiti libero di inviare loro uno shoutout d'incoraggiamento.",
    threeMonthsAccess: 'Hai tre mesi di accesso illimitato ',
    enjoyFreeAccess: 'Goditi i contenuti esclusivi degli atleti.',
    repostHeader:
      '<strong> {{owner}} <\/strong> post condiviso <strong> {{originalOwner}} <\/strong>',
    nowFollowing: 'Ora stai seguendo {{name}}',
    sureToRemove: 'Sei sicuro di voler rimuovere il tuo account? Questa azione è irreversibile.',
    getUnlimited: 'Ottieni contenuti illimitati',
    getUnlimitedDesc:
      'Iscriviti al tuo atleta preferito per essere aggiornato con contenuti esclusivi.',
    verifiedAthlete: 'Atleta verificato',
    callToAction: 'Condividi',
    mediaShare: 'Condivisione media',
    selectEngagement: 'Seleziona coinvolgimento',
    writeCaption: 'Scrivi una descrizione',
    engagement: 'Engagement'
  },
  notifications: {
    notifications: 'Notifiche',
    comingUpConnect: 'Il collegamento uno-a-uno con {{sender}} inizierà tra cinque minuti',
    connectRequest: 'Richiesta di collegamento uno-a-uno da {{sender}}',
    connectStatus: '{{status}} collegamento uno-a-uno con {{sender}}',
    connectStarting:
      'È ora di iniziare i tuoi 15 minuti di collegamento uno-a-uno prenotati con {{sender}}',
    commentedToPost: 'ha commentato il tuo post',
    commentedToSportChat: '<strong>{{sender}}</strong> \ncommented on your sport chat',
    reactedToPost: 'ha reagito al tuo post',
    reactedToShoutout: 'ha reagito al tuo shoutout',
    amountReactedToPost: '{{amount}} persone hanno reagito al tuo post',
    aNewShoutout: 'Hai un nuovo shoutout',
    newShoutouts: 'Hai {{amount}} nuovi shoutouts',
    shoutoutReaction: '{{sender}} ha reagito al tuo shoutout',
    startedFollowing: '{{sender}} ha iniziato a seguirti',
    amountStartedFollowing: 'Gli utenti di {{amount}} hanno iniziato a seguirti',
    newSub: 'Hai un nuovo abbonato',
    newSubs: 'Hai {{amount}} nuovi abbonati',
    newRequests: '{{amount}} nuove richieste per collegamento uno-a-uno',
    newFollower: 'ti ha seguito',
    taggedInPost: '<strong> {{sender}} <\/strong>\n sei stato taggato nel loro post',
    mentionedInPost: '<strong> {{sender}} <\/strong>\n sei stato menzionato nel loro post',
    commentTagged: '<strong> {{sender}} <\/strong>\n sei stato taggato nel loro commento',
    p4pMonetizingYourBrand: 'P4P sta monetizzando il tuo Brand!',
    fanRequestingShoutout: 'Un fan sta richiedendo uno shoutout.',
    view: 'Visualizzazione',
    congratulations: 'Congratulazioni!',
    yourFavoriteAthleteCompletedYourRequest:
      'Il tuo atleta prefrito ha completato il tuo shoutout.',
    sorryFavoriteAthleteCurrentlyUnavailable:
      'Ci dispiace, il tuo atleta preferito non è al momento disponibile. Puoi riprovare più tardi o seleziona un altro giocatore.',
    sender: '<strong>{{sender}}</strong>',
    sportChatCommentTagged: '<strong>{{sender}}</strong> \ntagged you in their sport chat comment',
    startedSubscribing: '<strong> {{sender}} <\/strong>\n è ora un tuo abbonato'
  },
  repost: {
    tagFriends: 'Tagga amici',
    repost: 'Riposta',
    create: 'Crea',
    yourComment: 'Il tuo commento',
    shareWith: 'Condividi con',
    everyone: 'Tutti',
    OnlyPeopleIFollowBack: 'Solo le persone che seguo'
  },
  onBoarding: {
    everybody: 'TUTTI',
    plays: 'GIOCHI',
    better: 'MEGLIO',
    together: 'INSIEME.',
    favoriteSports: 'I tuoi sport preferiti',
    chooseSports: 'Scegli lo sport e la tua squadra preferita per ternerti aggiornato.',
    selectSport: 'Seleziona lo sport',
    sport: 'Sport',
    favoriteTeam: 'Squadra Preferita',
    selectTeam: 'Seleziona una squadra',
    favoritePlayer: 'Atleta Preferito',
    selectPlayer: 'Seleziona un atleta',
    addMoreSport: 'Aggiungi più sport',
    getStarted: 'Inizia',
    youreAlmostThere: 'Ci sei quasi',
    tellUsAboutYourself: 'Parlaci di te per ricevere i feed e gli aggiornamenti più significativi.',
    imFrom: 'Vengo da',
    yourPhoneNumber: 'Il tuo numero di telefono',
    dateOfBirth: 'Data di nascita',
    monthlyRevenueTarget: 'Obiettivo di fatturato mensile',
    pleaseShareYour:
      'Condividi le tue aspettative di guadagno mensile. I tifosi non vedranno questo dato nel tuo profilo.',
    next: 'Prossimo',
    skipThisStep: 'Salta questo passaggio',
    yourSports: 'Il tuo sport',
    chooseASport: 'Scegli uno sport e indica la tua posizione.',
    mySport: 'Il mio sport',
    position: 'Posizione',
    selectPosition: 'Seleziona una Posizione',
    addSecondarySport: 'Aggiungi uno sport secondario',
    chooseSportsYou: 'Scegli gli sport che ti interessano.',
    skipAndGet: 'Salta e inizia',
    connectDirectlyWith: 'Messaggistica istantanea con i tuoi atleti preferiti e altri tifosi',
    monetizeYourBrand: 'Monetizza il tuo brand creando un mondo unico con i tuoi tifosi.',
    chooseAUsername: 'Scegli un nome utente',
    referralCodeOptional: 'Codice di referenza (facoltativo)',
    backTo: 'Torna a',
    logIn: 'Login',
    imAFan: 'Sono un tifoso',
    imAnAthlete: 'Sono un atleta',
    createAnAccount: 'Crea un account',
    searchTeams: 'Gruppi di ricerca'
  },
  shoutout: {
    success: 'Shoutout inviato con successo.',
    comingSoon: 'Shoutout è in arrivo presto',
    comingSoonDesc:
      'Comunica con atleti famosi in tutto il mondo, inviando messaggi motivanti e celebrativi.',
    selectTeamOrAthete: "Seleziona un Club o un'Atleta",
    teamOrAthlete: 'Club/Atleta',
    writeShoutout: 'Scrivi uno shoutout',
    createMatchDayShoutout: 'Crea un Matchday Shoutout',
    matchDayShoutouts: 'Match Day Shoutouts',
    shoutoutsFromAthletes: 'Dagli atleti',
    shoutoutsFromFans: 'Dai fan'
  },
  shop: {
    comingSoon: 'Il negozio sta arrivando',
    comingSoonDesc:
      "Merchandising dei vostri atleti preferiti, biglietti per eventi, offerte esclusive e molto altro ancora saranno disponibili nel nostro negozio. Ti informeremo presto dell'apertura."
  },
  header: {
    logOutConfirmation:
      'Sei uscito dal tuo account? È possibile accedere in un secondo momento utilizzando le tue credenziali.',
    upgradePlan: 'Piano di aggiornamento'
  },
  post: {
    timestampYear: 'y',
    timestampMonth: 'm',
    timestampWeek: 'w',
    timestampDays: 'd',
    timestampHour: 'h',
    timestampSecond: 's',
    deletePost: 'Cancella il post',
    editPost: 'Modifica il post',
    reportPost: 'Segnala il post',
    areYouSure: 'Sei sicuro di voler cancellare il tuo post?',
    reportingSoon: 'La segnalazione non è ancora disponibile. Si prega di tornare più tardi.',
    beingProcessed: 'Questo video è in fase di elaborazione, si prega di tornare più tardi.'
  },
  billing: {
    billing: 'Fatturazione',
    settings: 'Impostazioni',
    history: 'Storia',
    billingInformation: 'Informazioni sulla fatturazione',
    paymentMethod: 'Metodo di pagamento',
    addPaymentMethod: 'Aggiungi un metodo di pagamento',
    youNeedToAddMethod: 'È necessario aggiungere un metodo di pagamento',
    forYourPurches:
      'Verrai reindirizzato alla nostra APP per aggiungere il tuo metodo di pagamento.',
    goToWebApp: "Vai all'APP",
    exp: 'Esplora',
    removingCard: 'Questa carta verrà rimossa',
    sureToRemove: 'Sei sicuro di voler rimuovere **** {{last4}}?',
    noPaymentsYet: 'Non ci sono ancora pagamenti',
    processedPaymentsHere: "Qui viene visualizzato l'elenco dei pagamenti effettuati.",
    shoutoutTo: 'Shoutout a {{name}}',
    connectWith: 'Collegamento uno-a-uno con {{name}}',
    connectRefused: 'Collegamento uno a uno rifiutato da {{name}}',
    connectCanceledBy: 'Collegamento uno-a-uno annullato da {{name}}',
    termsAndConditions:
      "Come da Termini e Condizioni, accetto che mi venga addebitato l'importo sopra indicato al momento della conferma da parte di p4p.",
    swipeRightToPurchase: 'Scorri verso destra per acquistare',
    subscription: 'Iscriviti a {{name}}',
    productOrder: 'Ordine del prodotto',
    purchase: 'Acquisto'
  },
  revenueTarget: {
    none: 'Nessuno',
    oneThousand: 'Fino a 1.000 dollari',
    fiveThousand: 'Fino a 5.000 dollari',
    tenThousand: 'Fino a 10.000 dollari',
    hundredThousand: 'Fino a 100.000 dollari',
    oneMillion: 'Fino a 1.000.000 dollari',
    moreThanMillion: 'Più di 1.000.000 dollari'
  },
  forgotPassword: {
    recoveryEmailSent: 'E-mail di recupero inviata',
    checkYourInbox:
      'Controlla la posta in arrivo (e le cartelle di spam) per trovare e seguire le istruzioni per reimpostare la tua password.',
    backToLogin: 'Torna al Login',
    backToSettings: 'Torna alle Impostazioni',
    passwordReset: 'Ripristino della password',
    enterEmail:
      "Inserisci l'e-mail associata al tuo account e ti invieremo le istruzioni per il recupero della password.",
    sendRecovery: "Invia un'e-mail di recupero",
    checkEmail: 'Controlla il tuo indirizzo e-mail',
    noAccount: "Non c'è nessun account associato",
    anotherAddress: 'Cortesemente prova con un altro indirizzo.',
    tryAnother: "Prova a inviare un'altra e-mail",
    createNewPassword: 'Crea una nuova password',
    doesntMatch: 'Non corrisponde',
    newPassword: 'Nuova password',
    resetPassword: 'Reimposta la password',
    passwordRule1: 'La nuova password deve essere diversa da quella precedente.',
    passwordRule2: 'Almeno 8 caratteri: più sono, meglio è.',
    passwordRule3: 'La password deve contenere lettere maiuscole e minuscole.',
    passwordRule4: 'La password deve contenere lettere e numeri.',
    passwordRule5: 'Almeno un carattere speciale, ad esempio ! @ # ?'
  },
  getTheApp: {
    header: "Scarica l'APP playaz4playaz per il tuo smartphone",
    setupAccount:
      "Scarica l'APP playaz4playaz per il tuo smartphone per configurare il tuo account."
  },
  share: {
    repost: 'Riposta',
    copyLink: 'Copia il link',
    viaMessage: 'Condividi via e-mail',
    toFb: 'Condividi su Facebook',
    toInst: 'Condividi su Instagram',
    toTwit: 'Condividi su Twitter',
    toWhapp: 'Condividi su WhatsApp',
    toTelg: 'Condividi su Telegram',
    viaEmail: 'Condividi via e-mail',
    fb: 'Facebook',
    ig: 'Instagram',
    shareTo: 'Condividi su'
  },
  verification: {
    verifyProfile: 'Verifica il tuo profilo',
    verifyProfile2: 'Verifica il profilo',
    accountNeedsVerification:
      "Il tuo account deve essere verificato. Cortesemente, scatta un selfie con il tuo documento d'identità accanto alla tua faccia. Potrai farlo in seguito dal Profilo.",
    needVerification:
      'Il tuo account deve essere verificato per partecipare alle chiamate uno-a-uno.',
    yourProfileVerified: 'Il tuo profilo è stato verificato',
    verificationRequested: 'Richiesta di verifica',
    beingVerified:
      "Il profilo viene verificato entro 24 ore. Una volta terminata la verifica, dopo l'elaborazione del pagamento, sarà possibile effettuare il collegamento uno-a-uno",
    profileVerifiedDescription:
      'Grazie per aver completato la verifica. Ora è possibile partecipare alla sessione programmata di collegamento uno-a-uno.'
  },
  events: {
    shoutouts: 'Shoutout',
    livescore: 'Livescore',
    pictures: 'Immagini',
    stats: 'Statistiche',
    noShoutouts: 'Non ci sono ancora shoutout relativi a questo evento',
    addShoutout: 'Invia uno shoutout ora per essere il primo!'
  },
  games: {
    ht: 'Primo tempo',
    ft: 'Finale\n',
    matchday: 'Matchday {{round}}',
    roundOf16: 'Sedicesimi',
    quarterFinal: 'Quarto di finale',
    semiFinal: 'Semifinale',
    playOff: 'Playoff',
    playoffFinal: 'Finale dei Playoff',
    final: 'Finale',
    preSeason: 'Pre-campionato',
    playOffSemiFinal: 'Semifinale playoff',
    wantToShoutout: 'Vuoi procedere con uno shoutout?'
  },
  permissions: {
    permissionsBlocked: 'Permessi bloccati',
    goToYourSettings: 'Vai alle tue impostazioni e abilita {{permission}}',
    openSettings: 'Aprire le impostazioni',
    camera: 'Camera',
    microphone: 'Microfono',
    gallery: 'Galleria',
    openCamera: 'Apri la fotocamera'
  },
  store: {
    suggestedItems: 'Articoli suggeriti',
    liked: 'Piaciuto',
    merchandise: 'Merchandising',
    tickets: 'Biglietti',
    fromSubscribed: 'Per gli atleti iscritti',
    productDetails: 'Dettagli del prodotto',
    selectSize: 'Selezionare la taglia',
    selectStock: 'Seleziona il tipo',
    seeSizeGuide: 'Guarda la guida alle taglie',
    currentBid: 'Offerta attuale',
    placeBid: "Fai un'offerta",
    likedProducts: 'Prodotti che ti piacciono',
    noLiked: 'Ancora nessun prodotto di tuo gradimento',
    addToCart: 'Aggiungi al carrello',
    cart: 'Carrello',
    totalCost: 'Costo totale: ',
    checkout: 'Checkout',
    orderSuccessful: 'Ordine riuscito',
    size: 'Dimensione',
    price: 'Prezzo',
    proceedToPayment: 'Procedi al pagamento',
    sizeWithDesc: '{{size}} dimensione',
    clearAll: 'Cancella tutto'
  },
  goLive: {
    onlineCount: '{{onlineCount}} abbonati online',
    onlineCountFan: '{{onlineCount}} follower online',
    watchingCount: '{{watchingCount}} stanno visualizzando',
    youAreLive: 'Sei in diretta!',
    streamIsFinished: 'La diretta è terminata.',
    live: 'DIRETTA',
    end: 'Fine',
    comment: 'Commento',
    tapForGoLive: 'Clicca per andare in diretta'
  },
  subscribe: {
    monthly: 'Mensile',
    annual: 'Annuale',
    off: '{{amount}}% OFF',
    upToOff: 'FINO AL {{amount}}% di sconto',
    athletesAndTeams: 'Atleti e squadre',
    subscribeFor: 'Abbonati per <strong>{{amount}}\/mese<\/strong>',
    subscriptionSummary: "Riepilogo dell'abbonamento",
    introductoryOffer: 'Offerta introduttiva',
    annualDiscount: 'Paga 10 mesi per 12 con lo sconto annuale',
    noResults: 'Nessun risultato trovato con i criteri corrispondenti',
    teamFan: 'Tifoso del {{team}} ?',
    subscribeForTeam:
      'Abbonamento per tutti gli atleti della squadra da <strong>{{amount}}\/mese<\/strong>',
    seeAllAthletes: 'Vedi tutti {{number}} atleti',
    subscribeModalTitle: 'Abbonati ai tuoi atleti e alle tue squadre preferite',
    subscribeModalDesc:
      "Godititi i contenuti esclusivi degli atleti e delle squadre. Abbonati alle squadre per ottenere l'accesso completo ai giocatori a partire da 5,99 dollari.",
    athletesToSubscribe: 'Abbonarsi ad atleti',
    numberAthletes: 'atleti {{amount}}',
    cancelSubscription: "Annulla l'abbonamento",
    daysLeftInPeriod: '{{amount}} giorni rimanenti',
    sureToCancel: "Sei sicuro di voler annullare l'abbonamento?",
    bundleSquad: '{{name}} squadra',
    remindMeLater: 'Ricordami più tardi'
  },
  americanFootball: {
    quarterback: 'Quarterback',
    runningBack: 'Running Back',
    wideReceiver: 'Ricevitore',
    tightEnd: 'Tight End',
    leftGuard: 'Guardia',
    rightGuard: 'Guardia',
    center: 'Centro',
    leftTackle: 'Left Tackle',
    rightTackle: 'Right Tackle',
    noseTackle: 'Nose Tackle',
    defensiveTackles: 'Defensive Tackles',
    offensiveTackles: 'Offensive Tackle',
    offensiveLineman: 'Lineman',
    middleLineBacker: 'Linebacker',
    outsideLineBacker: 'Linebacker',
    defensiveBack: 'Defensive Back',
    flanker: 'Ricevitore',
    splitEnd: 'Ricevitore',
    kicker: 'Kicker',
    punter: 'Punter',
    cornerback: 'Cornerback',
    safety: 'Sicurezza',
    defensiveEnd: 'Defensive End',
    runningBackHalfback: 'Running Back (Halfback)',
    runningBackFullback: 'Running Back (Fullback)'
  },
  baseball: {
    centerFielder: 'Esterno Centro',
    pitcher: 'Lanciatore',
    catcher: 'Ricevitore',
    baseman: 'Prima Base',
    shortstop: 'Interbase',
    leftFielder: 'Esterno Sinistro',
    rightFielder: 'Esterno Destro',
    firstBaseman: 'Prima Base',
    secondBaseman: 'Seconda Base',
    thirdBaseman: 'Terza Base',
    designatedHitter: 'Battitore Designato'
  },
  basketball: {
    pointGuard: 'Playmaker',
    shootingGuard: 'Guardia tiratrice',
    smallForward: 'Ala piccola',
    powerForward: 'Ala Grande',
    center: 'Centro',
    comboGuard: 'Guardia Combinata',
    wingGuard: 'Guardia ',
    pointForward: 'Play',
    comboForward: 'Guardia'
  },
  cricket: {
    captain: 'Capitano',
    wicketkeeper: 'Guardiano del Wicket',
    slip: 'Slip',
    gully: 'Gully',
    point: 'Punto',
    cover: 'Copertina',
    thirdMan: 'Terzo Uomo',
    fineLeg: 'Fine Leg',
    midWicket: 'Centrocampista Wicket',
    midOff: 'Centrocampista Off',
    squareLeg: 'Square Leg'
  },
  soccer: {
    goalkeeper: 'Portiere',
    striker: 'Attaccante',
    centerbackStopper: 'Difensore Centrale',
    centerbackSweeper: 'Difensore Centrale',
    centerbackQuarterBack: 'Regista',
    rightFullback: 'Terzino destro',
    leftFullback: 'Terzino sinistro',
    centerForward: 'Centravanti',
    wingers: 'Ala',
    leftMid: 'Centrocampista sinistro',
    wideMid: 'Centrocampista',
    rightMid: 'Centrocampista destro',
    centerMid: 'Centrocampista centrale',
    attackingMid: "Centrocampista d'attacco",
    defensiveMid: 'Centrocampista difensivo',
    defensiveMidBallWinner: 'Centrocampista difensivo ',
    defensiveMidDeepLyingPlaymaker: 'Centrocampista difensivo (Playmaker)',
    boxToBoxMid: 'Centrocampista box-to-box',
    wingback: 'Ala\/Terzino',
    false9: 'Falso 9',
    raumdeuter: 'Raumdeuter',
    forward: 'Attaccante'
  },
  tennis: {
    oneUp: 'One-up',
    oneBack: 'One-Back'
  },
  handball: {
    goalkeeper: 'Portiere',
    leftBack: 'Difensore di Sinistra',
    centerBack: 'Difensore Centrale\/Centro',
    rightBack: 'Difensore di Destra',
    leftWinger: 'Ala Sinistra',
    centerForward: 'Centravanti\/Pivot\/Circle Runner',
    rightWinger: 'Ala Destra',
    farRight: 'Esterno Destro',
    halfRight: 'Mezzala Destra',
    backCenter: 'Difensore Centrale',
    frontCenter: 'Attaccante Centrale'
  },
  iceHockey: {
    leftDefenseman: 'Difensore sinistro',
    goaltender: 'Portiere\/Goalie',
    rightDefenseman: 'Difensore destro',
    leftWinger: 'Ala Sinistra',
    center: 'Centro',
    rightWinger: 'Ala Destra'
  },
  lacrosse: {
    attackmen: 'Attaccante',
    mid: 'Centrocampista',
    defensemen: 'Difensore',
    goalkeeper: 'Portiere'
  },
  polo: {
    lowWingLeftWing: 'Ala Bassa\/Ala Sinistra',
    lowWingRightWing: 'Ala Bassa\/ala Destra',
    centerHoleSet: 'Set',
    topWingLeftFlat: 'Ala Sinistra',
    topWingRightFlat: 'Ala Destra',
    point: 'Punto',
    cornerPost: 'Angolo\/post',
    middleDefense: 'Centro\/Difesa',
    topDefense: 'Top\/Difesa'
  },
  rowing: {
    coxswain: 'Timoniere',
    rower: 'Vogatore'
  },
  softball: {
    pitcher: 'Lanciatore',
    catcher: 'Ricevitore',
    firstBaseman: 'Prima base',
    secondBaseman: 'Seconda base',
    shortstop: 'Interbase',
    thirdBaseman: 'Terza base',
    leftFielder: 'Esterno Sinistro',
    centerFielder: 'Esterno Centro',
    rightFielder: 'Esterno Destro'
  },
  rugby: {
    looseheadProp: 'Pilone Sinistro',
    hooker: 'Tallonatore',
    tightheadProp: 'Pilone Destro',
    lock2ndRow: 'Seconda Linea',
    blindSideFlanker: 'Terza Linea Ala',
    openSideFlanker: 'Terza Linea Ala',
    number8: 'Terza Linea Centro',
    scrumHalf: 'Mediano di mischia',
    flyHalf: "Mediano d'apertura",
    leftWing: 'Trequarti Ala',
    insideCenter: 'Trequarti Centro',
    outsideCenter: 'Trequarti Centro',
    rightWing: 'Trequarti Ala',
    fullback: 'Estremo'
  },
  volleyball: {
    setter: 'Palleggiatore',
    outsideHitter: 'Schiacciatore laterale',
    middleBlocker: 'Centrale',
    libero: 'Libero',
    oppositeHitter: 'Opposto'
  },
  stories: {
    subscribeTo: 'Iscriviti per avere accesso ad altre storie di {{name}}'
  },
  reports: {
    descriptionPlaceholder: 'Descrivi la tua motivazione...',
    reportingPost: 'Segnalazione del post di {{name}}',
    reportingShoutout: 'Segnalazione dello shoutout di {{name}}',
    reportingStory: 'Segnalazione della storia di {{name}}',
    report: 'Segnalazione'
  },
  error: {
    noNetwork: 'Nessuna connessione di rete',
    somethingWentWrong: 'Qualcosa è andato storto!',
    pleaseTryAgainLater: 'Riprovare più tardi.'
  },
  requestShoutout: {
    discardChanges: 'Elimina le correzioni?',
    selectAthlete: 'Seleziona Atleta',
    newRequest: 'Nuova richiesta',
    requestAShoutout: 'Richiedi uno Shoutout',
    itsMine: "E' mio",
    forSomeoneElse: "Per qualcun'altro",
    whatIsYourName: 'Qual è il tuo nome?',
    introduction: 'Introduci te stesso',
    selectOcassion: 'Seleziona una motivazione',
    birthday: 'Compleanno',
    anniversary: 'Anniversario',
    motivational: 'Motivazionale',
    mentorship: 'Tutoraggio',
    gender: 'Genere',
    addInstruction: "Aggiungi un'istruzione (cosa vorresti che loro dicessero)",
    deliveryInfo: 'Informazione di consegna',
    videoDelivered: 'Il video sarà consegnato in {{day}} giorni',
    requestSent: 'La tua richiesta è stata inviata!',
    requestConfirmation:
      'Abbiamo appena inviato la tua richiesta di Shoutout a {{athlete}}. Il tempo di completamento non è oltre {{day}} giorni, siamo ottimisti che sarà così',
    whoThisFor: 'Per chi è questo?',
    standard: 'Standard ({{price}})',
    bookNow: 'Prenota ora',
    backToShoutout: 'Indietro agli Shoutouts',
    maximum18Chars: 'Massimo 18 caratteri',
    maximum200Chars: 'Massimo 200 caratteri',
    youCanAdd18Chars: 'Puoi digitare fino a 18 caratteri',
    youCanAdd200Chars: 'Puoi digitare fino a 200 caratteri'
  },
  yourRequests: {
    view: 'Visualizzazione',
    yourRequests: 'Le tue richieste',
    myShoutoutRequests: 'Le mie richieste di shoutout',
    shoutoutRequestsFromFans: 'Shoutout Requests from Fans',
    face2faceRequests: 'Rechieste Face2Face',
    all: 'Tutto',
    pending: 'In attesa di',
    completed: 'Completato',
    unfulfilled: 'Non completato',
    fromAthletes: 'Dagli atleti',
    fromFans: 'Dai fan',
    dayLeft: '{{dayLeft}} Giorno rimanente',
    daysLeft: '{{dayLeft}} Giorni rimanenti',
    fulfilledOn: 'Completato {{date}}',
    unfulfilledOn: 'Non completato {{date}}',
    decline: 'Rifiutare',
    startRecording: 'Inizio registrazione',
    record: 'Registrazione',
    tapForRecording: 'Seleziona per registrare',
    send: 'Invia',
    completeTheRequest: 'Completa la richiesta',
    discardChanges: 'Elimina le correzioni?',
    confirm: 'Conferma',
    cancel: 'Cancella',
    awesome: 'Fantastico!',
    shoutoutSuccessfullySent: 'Il tuo shoutout è stato inviato con successo',
    declineTheRequest: 'Rifiuta la richiesta',
    busyConsiderToProfit:
      'Comprendiamo che sei occupato, saremmo lieti se considerassi di monetizzare il tuo brand alla prossima richiesta da parte di un fan'
  },
  shoutoutsVideoGallery: {
    fromMe: 'Da me',
    fromFellowAthletes: 'Da altri atleti',
    for: 'per {{name}}'
  },
  letsChatSports: {
    startChat: 'Start Chat',
    writeTopic: 'Write a topic'
  },
  sorting: {
    mostRecent: 'Più recenti',
    oldest: 'Meno recenti'
  },
  callToAction: {
    follow: 'Connettiamoci! Seguimi per aggiornamenti.',
    subscribe: 'Più di semplici contenuti - abbonati per premi mensili!',
    requestShoutout: 'Il tuo nome, la mia voce - prendi il tuo saluto oggi!',
    sendShoutout: "Facciamo un po' di rumore - lascia il tuo Shoutout qui!",
    face2face: 'Vuoi un incontro uno a uno? Parliamo in diretta!',
    adPlayaz: 'Unisciti a noi - potenzia il tuo brand!',

    sendAShoutout: 'Invia uno shoutout',

    actionFollow: 'Connettiamoci!',
    actionSubscribe: "Sblocca l'accesso completo!",
    actionRequestShoutout: 'Ottieni il tuo shoutout!',
    actionSendShoutout: 'Invia uno shoutout!',
    actionF2F: 'Chattiamo live!',
    actionAdPlayaz: 'Potenzia il tuo brand!',

    warning: 'Avviso: ',
    mediaChange: ' I contenuti multimediali saranno modificati per essere visualizzati da',
    anyone: 'Chiunque',

    chooseEngagement: 'Per favore, scegli prima una tipologia di engagement',
    linkCopied: 'Il link è stato copiato negli appunti.',
    selectImage: "Seleziona o aggiungi un'immagine prima di condividere su Instagram."
  },
  updateApp: {
    newVersionAvailable: 'Nuova versione disponibile',
    pleaseUpdate: "Aggiorna l'app per continuare a usare Playaz4Playaz.",
    updateNow: 'Aggiorna ora'
  }
};
